import {ChartI, XyChartI} from "../../Types";
import {GREEN_COLOR, RED_COLOR} from "../../components/CONSTANTS";

const inmsgByTypesLong: ChartI<XyChartI> = {
    id: "inmsgByTypesLong",
    queryId: "inmsgByTypes",
    lang: {
        ua: 'Реєстрації за довгий період'
    },
    type: "xy",
    height: 450,
    parameters: {
        periods: ["Month1", "Month3", "Month6","Year1", "Year2", "Year3", "Year5", "Year7"],
        selectedPeriod: "Year1",
        selectedInterval: "Month1",
        filters: {
            from: {
                lang: {ua: 'З'},
                key: 'from',
                type: 'datetime'
            },
            to: {
                lang: {ua: 'До'},
                key: 'to',
                type: 'datetime'
            }
        }
    },
    settings: {
        yAxisName: 'Кількість',
        hideGlyphs: true,
        useAnimatedComponents: true,
        usePie: true,
        usePieNumberLabel: false,
        usePieNumberPercentage: true,
        pieShortNames: {
            correct: 'Кор',
            incorrect: 'Некор',
            duplicate: 'Дубль',
        },
        entries: [
            {
                key: 'incorrect',
                lang: {
                    ua: 'Некоректні'
                }
            }, {
                key: 'duplicate',
                lang: {
                    ua: 'Дублікат'
                }
            }, {
                key: 'correct',
                lang: {
                    ua: 'Коректні'
                }
            },
        ],
        colors: {
            correct: GREEN_COLOR,
            incorrect: RED_COLOR,
            duplicate: '#148aff',
        },
        glyphs: [],
        tooltipGlyphComponent: "🐋"
    }
}

export default inmsgByTypesLong
